import React from 'react';
import Slider from './Sections/Slider';
import Category from './Sections/Category';
import Services  from './Sections/Service';
import ServiceGuid from './Sections/ServiceGuid';
const product = {
  id: 1,
  name: 'Product Name',
  price: Number(),
  quantity: 1,
  thumb: 'https://example.com/product.jpg',
};
const App: React.FC = () => {
  return (
    <div className="App">
      <Slider />
      <Services/>
      <ServiceGuid />
      <Category/> 
    </div>
  );
}

export default App;